import styled from "styled-components"
import { colors } from "../../lib/colors"

interface history_header_each {
  isActive: boolean
}

interface history_win {
  isWin: boolean
}

export const HistoryContainer = styled.div<history_header_each>`
  /* margin-top: -30px; */
  opacity: ${({ isActive }) => (isActive ? 100 : 0)};
  transition: ${({ isActive }) =>
    isActive ? "all 0.5s ease 0.3s" : "all 0.5s ease"};
  user-select: none;
  @media only screen and (min-width: 768px) {
    height: calc(100% - 60px);
  }
`
export const HistoryWrapper = styled.div`
  height: 80vh;
  overflow-y: scroll;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }
  @media only screen and (min-width: 768px) {
    height: 100%;
  }
`
export const HistoryHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  user-select: none;
`

export const HistoryHeaderEach = styled.h1<history_header_each>`
  font-size: 12px;
  text-transform: uppercase;
  color: ${({ isActive }) => (isActive ? "white" : colors.headerColor)};
  /* font-weight: 400; */
  cursor: pointer;
  user-select: none;
  border-bottom: 1px solid
    ${({ isActive }) => (isActive ? colors.prevRoundBlue : "transparent")};
  @media only screen and (min-width: 600px) {
    font-size: 16px;
    margin-left: 10px;
  }
`
export const HistoryPageBox = styled.div<history_win>`
  margin-bottom: 5px;
  pointer-events: none;
  background-color: ${({ isWin }) =>
    isWin ? colors.liveScoreWinner : "rgba(28, 30, 36, 0.6)"};
  padding: 4px 10px;
  border-radius: 6px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
`

export const HistoryPageBoxHeader = styled.div<history_win>`
  max-width: 100px;
  h1 {
    font-size: 8px;
    line-height: 1;
    text-transform: uppercase;
    color: ${({ isWin }) =>
      isWin ? colors.historyWinHeader : colors.historyLooseHeader};
  }
  p {
    line-height: 1;
    overflow: hidden;
    text-align: start;
    text-overflow: ellipsis;
    font-size: 12px;
    max-width: 90%;
    color: ${({ isWin }) =>
      isWin ? colors.historyWinParagraph : colors.historyLooseParagraph};
  }
  @media only screen and (min-width: 600px) {
    h1 {
      font-size: 14px;
    }
    p {
      font-size: 16px;
    }
  }
`
